module.exports = __webpack_public_path__ + "static/media/google.60eb808d.svg";